
import React from 'react'
import { ApplicationState } from '../redux/state';
import {  Dispatch } from "redux";
import { connect } from 'react-redux';
import { fetchProductAttributes, updateInputData } from '../redux/product/productActions';
import { ClampexType } from '../types/types';

interface Props {
    shaftDiameter_d: number | undefined | null,
    hubInnerDiameter_d: number | undefined | null,
    product: ClampexType | undefined | null,
    fetchProductAttributes(product: any, shaftDiameter_d: number, hubInnerDiameter_d: number): any
    inputChanged(event: any): any
}

 function StoreWatcher(props: Props) {
    
    if(props.product !== undefined &&
        props.shaftDiameter_d !== undefined&&
        props.shaftDiameter_d !== null &&
        props.hubInnerDiameter_d !== null &&
        props.hubInnerDiameter_d !== undefined &&
        props.product !== null) {
        props.fetchProductAttributes(props.product, props.shaftDiameter_d, props.hubInnerDiameter_d);  
        
    }
    return ( <div></div> )
}


// REDUX PART --------------------------------------------------

const mapStateToProps = ({product} : ApplicationState) => ({
    shaftDiameter_d: product.productInputData.shaftDiameter_d,
    hubInnerDiameter_d: product.productInputData.hubInnerDiameter_D,
    product: product.currentProduct.type
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchProductAttributes:(product: ClampexType, shaftDiameter_d: number, hubInnerDiameter_d: number) => dispatch(fetchProductAttributes(product, shaftDiameter_d, hubInnerDiameter_d)),
    inputChanged:(event: any) => dispatch(updateInputData(event))
});


const connectedStoreWatcher = connect(
    mapStateToProps,
    mapDispatchToProps)(StoreWatcher)

export default connectedStoreWatcher;

